import { render, staticRenderFns } from "./resourcesDetail.vue?vue&type=template&id=9aa8e450&scoped=true&"
import script from "./resourcesDetail.vue?vue&type=script&lang=js&"
export * from "./resourcesDetail.vue?vue&type=script&lang=js&"
import style0 from "./resourcesDetail.vue?vue&type=style&index=0&id=9aa8e450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa8e450",
  null
  
)

export default component.exports